import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';

// Regroupe les chiffres par 3 avec une espace : 1200000 -> "1 200 000"
function grouper(val) {
  const digits = String(val ?? '').replace(/\D/g, '');
  if (!digits) return '';
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // espace insécable
}

// ============================================================
// Champ de saisie d'un MONTANT (argent)
// ============================================================
// - Affiche les chiffres groupés 3 par 3 pendant la frappe (lisibilité).
// - Affiche le libellé de la DEVISE du commerce en suffixe, à droite du champ.
//   La devise est lue automatiquement dans le contexte d'authentification
//   (paramètre du commerce, ex : GNF, XOF, EUR…), avec repli sur « GNF ».
// - PAS de flèches haut/bas (input texte, pas number).
// - Clavier numérique sur mobile (inputMode="numeric").
//
// Props :
//   value     : nombre (ou '' / null) — la valeur réelle.
//   onChange  : (nombre) => void — reçoit l'entier saisi (0 si vide).
//   devise    : surcharge du libellé affiché en suffixe.
//               - non fourni (défaut) → devise du commerce (contexte) ou 'GNF'.
//               - une chaîne          → force ce libellé.
//               - `null` ou ''        → masque le suffixe (utile là où un
//                                        suffixe est déjà positionné à la main).
//   className, placeholder, disabled… : transmis à l'input.
//
// Remplace un <input type="number" value={x||''} onChange={e=>setX(parseInt(e.target.value)||0)} />
// par <InputMontant value={x} onChange={setX} />
// ============================================================
export default function InputMontant({ value, onChange, className = '', placeholder = '0', devise, ...props }) {
  // Devise du commerce (via le contexte). useContext ne lève jamais d'erreur
  // hors provider — on retombe simplement sur 'GNF'.
  const auth = useContext(AuthContext);
  const deviseCommerce = auth?.commerce?.devise || 'GNF';
  // devise non fournie → auto ; fournie (chaîne / null / '') → on respecte.
  const deviseAffichee = devise === undefined ? deviseCommerce : devise;

  const affichage = value ? grouper(value) : '';
  const champ = (
    <input
      type="text"
      inputMode="numeric"
      autoComplete="off"
      value={affichage}
      onChange={e => {
        const digits = e.target.value.replace(/\D/g, '');
        onChange(digits === '' ? 0 : parseInt(digits, 10));
      }}
      placeholder={placeholder}
      // On réserve de la place à droite pour le suffixe devise.
      className={deviseAffichee ? `${className} pr-11` : className}
      {...props}
    />
  );

  if (!deviseAffichee) return champ;

  return (
    <div className="relative w-full">
      {champ}
      <span className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-gray-500 text-[11px] font-semibold">
        {deviseAffichee}
      </span>
    </div>
  );
}
